import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'

export const fields = (categories: string[]): ListFieldConfig => {
  return {
    name: { name: 'name', size: 250, index: 0 },
    description: { name: 'description', size: 250, index: 1, isVisible: false },

    category: {
      name: 'category',
      size: 250,
      index: 2,
      excludeOnSearch: true,
      type: ListFieldTypeEnum.select,
      fieldSettings: {
        listValues: categories,
      },
    },
  }
}
